import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteScheduledCustomSurvey } from '../../api/customSurveys';
import { GetScheduledCustomSurveysCacheKey } from '../queries/useGetScheduledCustomSurveysQuery';

export const useDeleteScheduledCustomSurveyMutation = (teamId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ surveyId }: { surveyId: number }) =>
      deleteScheduledCustomSurvey(teamId, surveyId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetScheduledCustomSurveysCacheKey.ScheduledCustomSurveys, teamId],
      });
    },
  });
};
